export default {
    tipoFaixa: {
        id: null,
        nome: '',
        ativo: true,
        lancaMensalidade: false,
        regraPrimeiraMensalidade: 'INTEGRAL',
        lancarNoTitular: false,
        consolidarNoTitular: false,
        periodicidade: 'MENSAL'
    },
    listTipoFaixa: [],
}
